<script setup lang="ts">
import { computed } from "vue";
import BannerImage from "~/components/layout/BannerImage.vue";

const props = defineProps<{
  error: Record<string, any>
}>();

useHead({
  title: 'Error',
});

const error = props.error || {};

const isDev = import.meta.dev;

const is404 = computed(() => {
  return (
    !error ||
    error.statusCode === 404 ||
    (error.message && error.message.includes('404'))
  );
});

const is504 = computed(() => {
  return error.message ? error.message.includes('504') : false;
});

const title = computed(() => {
  if (is404.value) {
    return 'Page not found';
  } else if (is504.value) {
    return 'Back Soon';
  } else {
    return 'An error occurred';
  }
});
</script>

<template>
  <div class="error-page">
    <banner-image :title="title" />

    <div class="container">
      <pre v-if="isDev">{{ error }}</pre>

      <div class="error-page__content">
        <template v-if="is404">
          <h2>We couldn't find that page</h2>
        </template>
        <template v-else-if="is504">
          <h2>The site is currently down for maintenance</h2>
        </template>
        <template v-else>
          <h2>There was a problem rendering that page</h2>
        </template>

        <a-button variant="primary" pill to="/">
          Back to Home
        </a-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.error-page {
  min-height: 90vh;

  &__content {
    text-align: center;
  }

  pre {
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 15px;
    background: #f3f2f1;
    margin-bottom: 30px;
  }
}
</style>
